import { z } from 'zod'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

import { InitializationCalldata } from '../../../cross-chain-deployment/InitializationCalldata'

export const InitializationCalldataSchema = z.string()

type InitializationCalldataReportText = z.infer<
  typeof InitializationCalldataSchema
>

export function mapDomainToReportText(
  postDeploymentModule: InitializationCalldata
): InitializationCalldataReportText {
  return postDeploymentModule.getValue().getValue()
}

export function mapReportTextToDomain(
  reportText: InitializationCalldataReportText
): InitializationCalldata {
  return InitializationCalldata.create({
    initializationCalldataValue: HexNumber.create({
      hexNumberValue: reportText,
    }),
  })
}
